import { useEffect, useRef, useState } from "react";
import { ArrayItems } from "./dropdownarray";
import { DropArrowIcon } from "@/assets/icons/admin";

interface DropdownProps {
  options: ArrayItems[];
  onSelect: (selectedOption: ArrayItems | null) => void;
  placeholder: string; // Placeholder text prop
  dropdownHeight?: string; // Dropdown height prop
  value?: string;
  dropdownColor?: string;
  className?: string;
}

const CustomDropdown: React.FC<DropdownProps> = ({
  options,
  onSelect,
  placeholder = "Select Page Access",
  dropdownHeight = "240px", // Default height if not provided
  value,
  dropdownColor = "input-bg border-white hover:bg-blue", // Default dropdown background color
  className,
}) => {
  const [selectedOption, setSelectedOption] = useState<ArrayItems | null>(null);
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (options !== undefined) {
      // Update selectedOption based on the value prop
      const option =
        options.find((opt: ArrayItems) => opt.value === value) || null;
      setSelectedOption(option || null);
    }
  }, [value, options]);

  const handleSelect = (option: ArrayItems) => {
    setSelectedOption(option);
    onSelect(option);
    setIsOpen(false);
  };

  const handleClickOutside = (event: MouseEvent) => {
    if (
      dropdownRef.current &&
      !dropdownRef.current.contains(event.target as Node)
    ) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div ref={dropdownRef} className={`relative ${className}`}>
      <div
        className={`${dropdownColor} shadow-xl flex h-10 w-full cursor-pointer items-center rounded-md border border-solid  border-opacity-50  p-2 pl-4 pr-4 backdrop-blur-xl`}
        onClick={() => setIsOpen(!isOpen)}
      >
        {selectedOption ? (
          <span className="text-white">{selectedOption.label}</span>
        ) : (
          <span className="text-md text-white">{placeholder}</span>
        )}
        <span className="ml-auto">
          <DropArrowIcon />
        </span>
      </div>
      {/* Dropdown list */}
      {isOpen && (
        <div
          className="shadow-lg absolute z-40 w-full overflow-y-auto rounded-md p-2"
          style={{ maxHeight: dropdownHeight }}
        >
          {/* Render options with specified styling */}
          {options &&
            options.map((option) => (
              <div
                key={option.value}
                className={`menu-item hovwr:text-white cursor-pointer px-4 py-2 hover:bg-blue`}
                onClick={() => handleSelect(option)}
              >
                {option.label}
              </div>
            ))}
        </div>
      )}
    </div>
  );
};

export default CustomDropdown;
